import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import {
	InjectedAppScrollerProps,
	withAppScroller,
} from 'src/_context/AppScroller';
import menuIcon from 'src/assets/icons/Menu.svg';
import titleLogo from 'src/assets/logos/aragon-logo-title.svg';
import responsive from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet, { directions } from 'src/constants/stylesheet';
import { NextLanguage } from 'src/utils/Languages';

export type HeaderProps = React.HTMLAttributes<HTMLElement> & {
	loading: boolean;
	openMenu: () => void;
};

const styles = {
	container: {
		background: 'white',
	},
	content: {
		display: 'flex',
		height: '100%',
		opacity: 0,
		transform: 'translate3d(0, -100%, 0)',
		transition: 'all 0.7s ease-out',
		alignItems: 'center',
		...stylesheet.PaddingGutter(1, directions.all),
		position: 'relative',
		'&:after': {
			content: '""',
			position: 'absolute',
			...stylesheet.MarginGutter(1, directions.sides),
			left: 0,
			right: 0,
			backgroundColor: 'black',
			height: 1,
			zIndex: 999,
			bottom: 0,
		},
	},
	menuIcon: {
		height: 13,
		marginRight: 10,
	},
	menu: {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
	},
	menuLegend: {
		...stylesheet.Caption,
		lineHeight: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		whiteSpace: 'nowrap',
		height: spacing.Header.menuHeight,

		[responsive.Mobile]: {
			display: 'none',
		},
	},
	menuLegendText: {
		marginTop: -spacing.Header.menuHeight,
		height: spacing.Header.menuHeight,
		lineHeight: `${spacing.Header.menuHeight}px`,
		opacity: 0,
		transition: 'opacity 0.2s linear',
		'&:first-child': {
			marginTop: 0,
		},
	},
	menuLegendTextActive: {
		opacity: 1,
	},
	logo: {
		flex: 0,
		[responsive.BeforeTablet]: {
			height: 20,
		},
		[responsive.AfterTablet]: {
			height: 25,
		},
	},
	logoImage: {
		height: '100%',
	},
	logoIcon: {
		height: '100%',
		width: 'auto',
		maxWidth: 'none',
	},
	languages: {
		flex: 1,
		whiteSpace: 'nowrap',
		...stylesheet.Caption,
		textAlign: 'right',
	},
	languageLink: {
		display: 'none',
		...stylesheet.Caption,
		[responsive.Mobile]: { display: 'none' },
	},
	languageLinkMobile: {
		display: 'none',
		[responsive.AfterMobile]: { display: 'none' },
	},
	loaded: {
		'& $content': {
			opacity: 1,
			transform: 'translate3d(0, 0, 0)',
		},
	},
};

type Props = HeaderProps &
	StyledComponentProps<keyof typeof styles> &
	InjectedAppScrollerProps;

type State = {};

class Header extends React.Component<Props, State> {
	state: {};
	render() {
		const {
			children,
			classes,
			openMenu,
			loading,
			appScrollerCtx,
			appScrollerCtx: { currentUrl, parts, Top },
			...rest
		} = this.props;
		const current = parts.find(
			(p) => !!(currentUrl && currentUrl.indexOf(p.url) === 0)
		);
		return (
			<header
				{...rest}
				className={classNames(
					classes!.container,
					!loading && classes!.loaded,
					rest.className
				)}
			>
				<div className={classNames(classes!.content)}>
					<a onClick={openMenu} className={classes!.menu}>
						<img src={menuIcon} alt='menu icon' className={classes!.menuIcon} />
						<span className={classes!.menuLegend}>
							{parts
								.filter((p) => p.title)
								.map((p) => {
									const active = currentUrl && currentUrl.indexOf(p.url) === 0;
									return (
										<span
											className={classNames(
												classes!.menuLegendText,
												active && classes!.menuLegendTextActive
											)}
											key={p.url}
										>
											{p.title}
										</span>
									);
								})}
							<span
								className={classNames(
									classes!.menuLegendText,
									(!current || !current.title) && classes!.menuLegendTextActive
								)}
								key='default'
							>
								Menu
							</span>
						</span>
					</a>
					<a onClick={Top} className={classes!.logo}>
						<img src={titleLogo} className={classes!.logoIcon} />
					</a>
					<div className={classes!.languages}>
						<a href={`?switch-lang=en`} className={classes!.languageLink}>
							EN /
						</a>
						<a href={`?switch-lang=fr`} className={classes!.languageLink}>
							{' '}
							FR
						</a>
						<a
							href={`?switch-lang=${NextLanguage}`}
							className={classes!.languageLinkMobile}
						>
							{NextLanguage}
						</a>
					</div>
					{children}
				</div>
			</header>
		);
	}
}

export default withStyles(styles)(withAppScroller(Header));



// WEBPACK FOOTER //
// ./src/components/Header.tsx